import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Highlight from '@tiptap/extension-highlight';
import EditorToolbar from './EditorToolbar';
import { useEffect } from 'react';


const Tiptap = (props) => {
	const handleUpdate = (result) => {
		const content = result.editor.getHTML();
		if (content !== props.content) {
			props.callback(content);
		}
	}
	const handlePaste = (event) => {
		event.preventDefault();

		const html = event.clipboardData?.getData('text/html') || '';
		const text = event.clipboardData?.getData('text/plain') || '';

		return false;

		// console.log('html', html);
		// console.log('text', text);

		// if (html) {
		// 	const cleaned = cleanPastedText(html) // now also unwraps anchors
		// 	if (cleaned) {
		// 		console.log('inserting cleaned html', cleaned);
		// 		editor.commands.insertContent(cleaned);
		// 		return true;
		// 	}
		// }
		// if (text) {
		// 	const safe = text.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>').replace(/\n/g, '');
		// 	console.log('inserting text', safe);
		// 	editor.commands.insertContent([{
		// 		type: 'text',
		// 		text: safe,
		// 	}]);
		// 	return true;
		// }
		// return true;
	}

	const cleanPastedText = (htmlContent) => {
		const textNodes = ["p", "span"];
		const allowedTags = [...textNodes, "br", "ul", "ol", "li"];

		try {
			const parser = new DOMParser();
			const doc = parser.parseFromString(htmlContent, "text/html");

			doc.body.querySelectorAll('a').forEach(a => a.replaceWith(...a.childNodes));

			const documentBodyElements = doc.body.querySelectorAll("*");

			documentBodyElements.forEach((element) => {
				const elementTagName = element.tagName.toLowerCase();
				const isAllowedTag = allowedTags.includes(elementTagName);

				if (!isAllowedTag) {
					element.replaceWith(...element.childNodes);
				}
			});

			return doc.body.innerHTML;
		} catch {
			console.error("Clipboard data is invalid text/html");
			return null;
		}
	}

	const editor = useEditor({
		extensions: [
			StarterKit.configure({
				link: {
					protocols: ['https', 'http', 'mailto', 'tel'],
					defaultProtocol: 'https',
					autolink: false,
					linkOnPaste: false,
					openOnClick: false,
				}
			}),
			Highlight,
			Placeholder.configure({
				placeholder: "Article goes here",
			}),
		],
		content: `${props.content}`,
		onUpdate: handleUpdate,
		onPaste: handlePaste,
	});

	useEffect(() => {
		if (editor.getHTML() !== props.content) {
			editor.commands.setContent(props.content);
		}
	}, [props.content, editor]);

	return (
		<>
		<EditorToolbar editor={editor} />
		<EditorContent editor={editor} />
		</>
	)
}

export default Tiptap;
